import { createFileRoute } from '@tanstack/react-router';
import { AdminPage } from '@/components/backoffice/AdminPage';
import { apiUrlFrom } from '@/app/env';
import { t } from '@/i18n/index';

/**
 * The backoffice (docs/plan/controlled-playtests.md): passes, sessions and their cost,
 * accounts, settings and the playtest requests, behind one bearer secret the pod checks.
 * Without a pod there is nothing to administer, and the page says so.
 */
export const Route = createFileRoute('/admin')({
  head: () => ({
    meta: [{ title: 'Backoffice — Everwake' }, { name: 'robots', content: 'noindex' }],
  }),
  component: AdminRoute,
});

function AdminRoute() {
  const apiUrl = apiUrlFrom();
  if (!apiUrl) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <p className="max-w-md text-center text-sm text-muted-foreground">{t('ui.admin.no_pod')}</p>
      </div>
    );
  }
  return <AdminPage apiUrl={apiUrl} />;
}
